"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersistentRetailSession = void 0;
const react_1 = require("react");
const useClient_1 = require("../../../../../hooks/useClient");
const RETAIL_SESSION_ID = "retail-session-id";
const PersistentRetailSession = ({ children }) => {
    const client = (0, useClient_1.useClient)();
    (0, react_1.useEffect)(() => {
        // try and login with credentials store in local storage
        const sessionId = window.localStorage.getItem(RETAIL_SESSION_ID);
        if (sessionId) {
            // this will trigger onSessionChange
            client.auth.setSessionFromSessionId(sessionId).catch(console.error);
        }
        const handlePersistentRetailSession = () => {
            // get session from client
            const session = client.auth.session;
            // if no session we clear it
            if (session === null) {
                window.localStorage.removeItem(RETAIL_SESSION_ID);
            }
            else {
                // otherwise we set the session and store it locally
                window.localStorage.setItem(RETAIL_SESSION_ID, session.sessionId);
            }
        };
        client.auth.on("sessionChange", handlePersistentRetailSession);
    }, []);
    return children;
};
exports.PersistentRetailSession = PersistentRetailSession;
//# sourceMappingURL=index.js.map